import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronRightMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChevronRightMedium"><Path d="M16.9141 12L9.5 19.4141L8.08594 18L14.0859 12L8.08594 6L9.5 4.58594L16.9141 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronRightMedium;
